import { AfterViewInit, Component,  effect,  ElementRef, input, OnDestroy, OnInit, output, signal, untracked, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-drag-and-drop',
    imports: [MatIconModule, CommonModule],
    templateUrl: './drag-and-drop.component.html',
    styleUrls: ['./drag-and-drop.component.scss']
})
export class DragAndDropComponent implements OnInit, OnDestroy{
  imageName = signal('');
  fileSize = signal(0);
  imagePreview = signal('');
  uploadSuccess = signal(false);
  uploadError = signal(false);
  errors = signal({
    fileSizeError: false,
    noImageError: false,
    unsupportedFormatError: false, 
  });
  
  @ViewChild('fileInput') fileInput: ElementRef | undefined;
  selectedFile = signal<File | null>(null);
  fileUploaded = output<File | null>();
  cleanSignal = input<boolean>(false)
  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0] || null;
    this.uploadFile(file);
  }
  
  constructor() {
    effect(() => {
      if (this.cleanSignal()) {       
        untracked(() => {
          this.cleanContainer();
        });
      }
    });
  }

  onFileDrop(event: DragEvent): void {
    event.preventDefault();
    this.cleanContainer()
    const file = event.dataTransfer?.files[0] || null;
    this.uploadFile(file);
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  uploadFile(file: File | null): void {
    if (!file) return;
  
    this.cleanContainer();
  

    if (!file.type) {
      this.uploadError.set(true);
      this.errors.set({
        fileSizeError: false,
        noImageError: true, 
        unsupportedFormatError: false,
      });
      return;
    }
  
    const supportedFormats = ['image/jpeg', 'image/png'];
  

    if (!supportedFormats.includes(file.type)) {
      this.uploadError.set(true);
      this.errors.set({
        fileSizeError: false,
        noImageError: false,
        unsupportedFormatError: true, 
      });
      return;
    }
  
    if (file.size > 3 * 1024 * 1024) {
      this.uploadError.set(true);
      this.errors.set({
        fileSizeError: true, 
        noImageError: false,
        unsupportedFormatError: false,
      });
      return;
    }
  

    this.selectedFile.set(file);
    this.imageName.set(file.name);
    this.fileSize.set(Math.round(file.size / 1024));
  

    const reader = new FileReader();
    reader.onload = (e) => {
      const result = e.target?.result as string;
      this.imagePreview.set(result);
    };
    reader.readAsDataURL(file);
  

    this.uploadSuccess.set(true);
    this.errors.set({
      fileSizeError: false,
      noImageError: false,
      unsupportedFormatError: false,
    });
  }
  
  
  
  removeImage(event: Event): void {
    if (event) event.stopPropagation();
    this.cleanContainer();
  }

saveImageToS3(event: Event): void {
  if (event) event.stopPropagation();
  const file = this.selectedFile(); 
  if (file) {
    this.fileUploaded.emit(file);
    this.cleanContainer()
  } else {
    console.error('No file selected to upload'); 
  }
}

ngOnInit(): void {
  this.cleanContainer(); 
}
ngOnDestroy(): void {
  this.cleanContainer(); 
}


cleanContainer(): void {
  this.selectedFile.set(null); 
  this.imageName.set('');
  this.fileSize.set(0); 
  this.imagePreview.set(''); 
  this.uploadSuccess.set(false); 
  this.uploadError.set(false); 
  this.errors.set({
    fileSizeError: false,
    noImageError: false,
    unsupportedFormatError: false,
  });

  const imgElement = document.querySelector('.image-preview') as HTMLImageElement;
  if (imgElement) {
    imgElement.src = ''; 
  }


  if (this.fileInput?.nativeElement) {
    (this.fileInput.nativeElement as HTMLInputElement).value = '';
  }
}

}
